module.exports = __webpack_public_path__ + "media/images/web_suite/bio_icon-9f25bf2be5bb4b1bc9746c45a509465f.png";